import { useFormik } from "formik";
import type React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ModalTitle } from "src/components/Modals/Components/ModalsComponents";
import { DescriptionArea } from "src/components/NewComponents/Filters/FlashcardsFilters/PermissionFilter";
import DefaultModal from "src/components/NewComponents/Modals/DefaultModal";
import WarningIcon from "src/images/Icons/newIcons/warrning.svg";
import * as Yup from "yup";

interface DefaultReportModalProps {
	onClose: () => void;
	onSubmit: (values: { message: string }) => void;
	title: string;
	subtitle: string | React.ReactNode;
	placeholder: string;
	renderSuccess: () => React.ReactNode;
	primaryText: string;
}

export const DefaultReportModal = ({
	onClose,
	onSubmit,
	title,
	subtitle,
	placeholder,
	renderSuccess,
	primaryText,
}: DefaultReportModalProps) => {
	const { t } = useTranslation();
	const [isSuccess, setIsSuccess] = useState(false);
	const { handleSubmit, setFieldValue, values, errors } = useFormik({
		initialValues: {
			message: "",
		},
		onSubmit: async ({ message }, { resetForm }) => {
			onSubmit({ message });
			setIsSuccess(true);
			resetForm();
		},
		validationSchema: Yup.object().shape({
			message: Yup.string().required(t("errors.emptyField")),
		}),
	});

	return (
		<DefaultModal
			onClose={onClose}
			primaryText={primaryText}
			onPrimaryClick={handleSubmit}
			secondaryText={t("commands.cancel")}
			onSecondaryClick={onClose}
			fullWidth
			isSuccess={isSuccess}
			renderSuccess={renderSuccess}
		>
			<ModalTitle Icon={WarningIcon} title={title} />
			<div className="flex items-center justify-center flex-col w-100 gap-12">
				<p className="size-16-light text-grey">{subtitle}</p>
				<DescriptionArea
					className="w-100"
					label={placeholder}
					description={values.message}
					setDescription={(value: string) => setFieldValue("message", value)}
					error={errors.message}
				/>
			</div>
		</DefaultModal>
	);
};
